;(function() {
  'use strict'

  service.$inject = ["$q", "$log", "imagesResource"];
  angular.module('core.services').factory('imageService', service)

  /* @ngInject */
  function service($q, $log, imagesResource) {
    var log = $log.create('imageService')

    return {
      upload: upload,
    }

    function upload(imageData) {
      return $q(function(resolve, reject) {
        imagesResource
          .create({ imageData: imageData })
          .success(function(resource, response) {
            resolve(response.imageUrl)
            log.info('uploaded image', response.imageUrl)
          })
          .error(function(response, status) {
            reject()
            log.error('error uploading image', status, response)
          })
      })
    }
  }
})()
